<template>
  <v-main>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mt-n2">{{ $t('Reports') }} - {{ $t('Registrations') }}</h1>
        </v-flex>
        <v-flex xs12>
          {{ $t('Search criteria') }}
        </v-flex>
        <v-flex xs12 md6>

          <InputFilter :label="$t('Date')">
            <template slot="min">
              <DatePicker v-model="filters.DateFrom" label="Minimum date"></DatePicker>
            </template>
            <template slot="max">
              <DatePicker v-model="filters.DateTo" label="Maximum date"></DatePicker>
            </template>
          </InputFilter>

          <InputFilter :label="$t('Agreement')">
            <template slot="min">
              <v-text-field v-model="filters.AgreementFrom" solo hide-details></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.AgreementTo" solo hide-details></v-text-field>
            </template>
          </InputFilter>

          <InputFilter :label="$t('Delivery')">
            <template slot="min">
              <v-text-field v-model="filters.DeliveryFrom" solo hide-details></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.DeliveryTo" solo hide-details></v-text-field>
            </template>
          </InputFilter>

          <InputFilter :label="$t('Article')">
            <template slot="min">
              <v-text-field v-model="filters.ArticleFrom" solo hide-details></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.ArticleTo" solo hide-details></v-text-field>
            </template>
          </InputFilter>

          <InputFilter :label="$t('Customer')">
            <template slot="min">
              <v-text-field v-model="filters.CustomerFrom" solo hide-details></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.CustomerTo" solo hide-details></v-text-field>
            </template>
          </InputFilter>

          <InputFilter :label="$t('Carrier')">
            <template slot="min">
              <v-text-field v-model="filters.CarrierFrom" solo hide-details></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.CarrierTo" solo hide-details></v-text-field>
            </template>
          </InputFilter>

        </v-flex>
        <v-flex xs12 md6 class="mb-5">

          <InputFilter :label="$t('Facilities')">
            <FacilityPicker v-model="filters.FacilityArray"></FacilityPicker>
          </InputFilter>

          <InputFilter :label="$t('RegistrationNo')">
            <template slot="min">
              <v-text-field v-model="filters.RegistrationNoFrom" solo hide-details type="number"></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.RegistrationNoTo" solo hide-details type="number"></v-text-field>
            </template>
          </InputFilter>

          <InputFilter :label="$t('ScanXRegNo')">
            <template slot="min">
              <v-text-field v-model="filters.ScanXRegNoFrom" solo hide-details type="number"></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.ScanXRegNoTo" solo hide-details type="number"></v-text-field>
            </template>
          </InputFilter>

          <InputFilter :label="$t('Requisition')">
            <template slot="min">
              <v-text-field v-model="filters.RequisitionFrom" solo hide-details></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.RequisitionTo" solo hide-details></v-text-field>
            </template>
          </InputFilter>

          <InputFilter :label="$t('Vehicle')">
            <template slot="min">
              <v-text-field v-model="filters.VehicleFrom" solo hide-details></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.VehicleTo" solo hide-details></v-text-field>
            </template>
          </InputFilter>

          <!-- <InputFilter :label="$t('Text search')">
            <v-text-field v-model="filters.TextSearch" solo hide-details></v-text-field>
          </InputFilter> -->
          <InputFilter :label="$t('Producer')">
            <template slot="min">
              <v-text-field v-model="filters.ProducerFrom" solo hide-details></v-text-field>
            </template>
            <template slot="max">
              <v-text-field v-model="filters.ProducerTo" solo hide-details></v-text-field>
            </template>
          </InputFilter>

          <InputFilter :label="$t('Cancelled registrations')">
            <v-checkbox v-model="filters.CancelledRegistrations" solo hide-details></v-checkbox>
          </InputFilter>
            <v-flex v-if="showOutGoingCheckbox"  class="mr-1">
              <InputFilter :label="$t('Ignore Ingoing')">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-simple-checkbox v-model="filters.OnlyShowOutGoingRegistrations" v-on="on"></v-simple-checkbox>
                  </template>
                  <span>{{$t("Exclude registrations with first weight higher than second")}}</span>
                </v-tooltip>
              </InputFilter>
            </v-flex>
        </v-flex>
        <v-flex md8 xs12>
          <v-layout>
            <v-flex xs4><v-btn block large :loading="loading" color="primary" @click="getData"><v-icon left>search</v-icon>{{ $t('Search') }}</v-btn></v-flex>
            <v-flex xs4><ColumnsPicker v-model="headers"></ColumnsPicker></v-flex>
            <v-flex xs4><v-select height="43" clearable dense :items="translatedHeaders" v-model="group" label="Group by" solo hide-details></v-select></v-flex>
          </v-layout>
        </v-flex>
        <v-flex md4 xs12>
          <v-layout>
            <v-flex><v-btn block large color="white" :disabled="!results.length || loading" class="mr-2" @click="print"><v-icon left>print</v-icon>Print</v-btn></v-flex>
            <v-flex><v-btn block large color="white" :disabled="!results.length || loading" class="mr-2" @click="download"><v-icon left>cloud_download</v-icon>{{ $t('Export') }}</v-btn></v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <span>{{ results.length }}</span>
          <span> {{ $t("Results").toLowerCase() }}</span>
        </v-flex>
        <v-flex xs12 id="section-to-print">
          <!-- <v-flex class="text-center"> Works fine for HTML, but not Window.print() -->
          <v-flex>
            <img :src="logo" v-show="showLogo" class="show-on-print">
          </v-flex>
         <v-flex>
          <v-data-table id="table-to-print"
            :headers="filteredHeaders"
            :items-per-page="-1"
            class="elevation-1"
            :items="formattedResults"
            :loading="loading"
            hide-default-footer
            :group-by="group"
            :group-desc="false"
          >
            <template v-slot:[`group.header`]="props">
              <td :colspan="props.headers.length" class="primary white--text">
                <span class="font-weight-bold">{{ $t(group) }} </span>
                <span>{{ props.group }}</span>
              </td>
            </template>
            <template v-slot:[`group.summary`]="props">
              <td :colspan="props.headers.length" class="text-right font-weight-bold">
                {{ getWeight(props.items) }}
              </td>
            </template>
            <template v-slot:[`item.WeightFirst`]="{ item }">
              <span style="float: right;"> {{ formatWeight(item.WeightFirst) }}</span>
            </template>
            <template v-slot:[`item.WeightSecond`]="{ item }">
              <span style="float: right;"> {{ formatWeight(item.WeightSecond) }}</span>
            </template>
            <template v-slot:[`item.WeightNet`]="{ item }">
              <span style="float: right;"> {{ formatWeight(item.WeightNet) }}</span>
            </template>
            <template v-slot:[`item.Print`]="{ item }">
                <v-btn
                @click="printConfirmation(item, 2)"
              >{{$t('Print')}}</v-btn>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-btn color="primary" :to="{name: 'editAsphalt-delivery-vehicles', params: {id: item.Id, facilityNo: item.Facility, no: item.No}}">
                  <v-icon left>edit</v-icon>
                  {{$t("Edit")}}
                </v-btn>
              </td>
            </template>
            <template v-slot:[`body.append`]="props">
              <tr class="v-row-group__summary">
                <td :colspan="props.headers.length" class="text-right font-weight-bold">
                  Total sum: {{ getWeight(props.items) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import DatePicker from '@/core/components/DatePicker'
import InputFilter from '@/modules/reports/components/Filter'
import FacilityPicker from '@/modules/reports/components/FacilityPicker'
import ColumnsPicker from '@/modules/reports/components/ColumnsPicker'
import * as Reports from '@/modules/reports/reports'
import moment from 'moment'
import formatDate from '@/core/mixins/formatDate'
import downloadExcel from '@/core/imports/downloadExcel'
import { UserDetail } from '@/core/userDetail'
import * as Security from '@/core/security'
import { CorporationDetail } from '@/core/corporationDetail'
import rules from '@/core/mixins/common-rules'
import { loadFacilities } from '@/core/archive'
import _ from 'lodash' // clone
import * as LocalStorage from '@/core/local-storage'

// import * as Utils from '@/core/utils'
// import * as Admin from '@/core/admin'
// import { app } from '@/main'
// import printJS from 'print-js'
// import * as LocalStorage from '@/core/local-storage'
export default {
  mixins: [formatDate, rules],
  components: {
    DatePicker,
    InputFilter,
    FacilityPicker,
    ColumnsPicker
  },
  data () {
    return {
      showLogo: false,
      userDetailFilter: null,
      loading: false,
      id: '00000000-0000-0000-0000-000000000000',
      details: [],
      logo: null,
      showOutGoingCheckbox: false,
      showComfirmationPrint: false,
      // redirectTo: 'registrations',
      printTitle: '',
      filters: {
        DateFrom: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        DateTo: moment().format('YYYY-MM-DD'),
        AgreementFrom: '',
        AgreementTo: '',
        DeliveryFrom: '',
        DeliveryTo: '',
        ArticleFrom: '',
        ArticleTo: '',
        CustomerFrom: '',
        CustomerTo: '',
        CarrierFrom: '',
        CarrierTo: '',
        FacilityArray: [],
        RegistrationNoFrom: '',
        RegistrationNoTo: '',
        ScanXRegNoFrom: '',
        ScanXRegNoTo: '',
        RequisitionFrom: '',
        RequisitionTo: '',
        VehicleFrom: '',
        VehicleTo: '',
        // TextSearch: ' ',
        ProducerFrom: '',
        ProducerTo: '',
        CancelledRegistrations: false,
        OnlyShowOutGoingRegistrations: false
      },
      results: [],
      headers: [],
      useFacilityDescription: false,
      group: undefined
    }
  },
  async mounted () {
    await Security.autoLogin()// Make sure we are logged in, since user is needed to get filters (User Details)
    this.userDetailfilter = await UserDetail.load(Security.user.id, 'ReportRegistrationFieldsFilter')
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    if (process.env.NODE_ENV === 'development') console.log('--> Loaded User Detail from REGISTRATION', this.userDetailfilter)
    if (this.userDetailfilter.Data1) {
      this.filters = JSON.parse(this.userDetailfilter.Data1)
    } else {
      this.userDetailfilter.Data1 = this.filters
    }
    noValue = Security.user.corporationDetails.find(d => d.Name === 'Reports_Show_OnlyOutGoingRegs_RegistrationCheckbox')?.Data1 === undefined ?? false
    if (noValue) {
      this.showOutGoingCheckbox = false
    } else {
      this.showOutGoingCheckbox = Security.user.corporationDetails.find(d => d.Name === 'Reports_Show_OnlyOutGoingRegs_RegistrationCheckbox')?.Data1 === 'true' ?? false
    }
    const res = await CorporationDetail.loadFromUser('logo')
    if (res && res.Data3) {
      if (res.Data1.toLowerCase().includes('jpg')) this.logo = 'data:image/jpg;base64,' + res.Data3
      else this.logo = 'data:image/png;base64,' + res.Data3
    }
    if (process.env.NODE_ENV === 'development') console.log('--> Loaded logo in registration', res)
    // await this.getData() lets not auto search (so user does not need to wait for the result and we save some cpu on the server)
    this.showComfirmationPrint = Security.user.corporationDetails.find(d => d.Name === 'Reports_Show_PrintConfirmation_RegistrationCheckbox')?.Data1 === 'true' ?? false
    for (let i = 0; i < this.translatedHeaders.length; i++) {
      if (this.translatedHeaders[i].text === 'Print') {
        this.translatedHeaders[i].visible = this.showComfirmationPrint
      }
    }
    for (let i = 0; i < this.headers.length; i++) {
      if (this.headers[i].text === 'Print') {
        this.headers[i].visible = this.showComfirmationPrint
      }
    }
    const printed = '' + LocalStorage.load('printed')
    if (printed !== null && printed !== 'null') {
      console.log('printed data reload')
      LocalStorage.remove('printed')
      this.getData()
    }
  },
  watch: {
    filters: {
      handler (val) {
        if (!this.loading) {
          if (process.env.NODE_ENV === 'development') console.log('--> Saving User Detail from REGISTRATION', this.userDetailfilter, JSON.stringify(val))
          if (this.userDetailfilter) {
            this.userDetailfilter.Data1 = JSON.stringify(val)
            this.userDetailfilter.save()
          }
        }
        // LocalStorage.save(user.token.User + 'columns', JSON.stringify(val))
      },
      deep: true
    }
  },
  methods: {
    formatWeight (weight) {
      return parseFloat(weight).toLocaleString()
    },
    getWeight (items) {
      return this.formatWeight(items.reduce((a, b) => a + b.WeightNet, 0))
    },
    getSum (field) {
      let sum = 0
      for (const r of this.results) {
        sum = sum + r.WeightNet
      }
      return sum
    },
    async printConfirmation (reg, state) {
      LocalStorage.save('printed', true)
      const res = await Reports.loadFacilityData({ facilityNo: reg.Facility, corpName: Security.user.corporation })
      if (!res.failed) {
        this.details = res.data.Details
        const printTitleDetail = this.details.find(o => o.Name === 'printTitle')
        if (printTitleDetail !== undefined) {
          this.printTitle = printTitleDetail.Value
        }
        this.$router.push({ name: 'print-registration-confirmation', params: { id: reg.Id, header: this.printTitle } })
        // this.openInTab({ name: 'print-registration-confirmation', params: { id: reg.Id, header: this.printTitle } })
      }
    },
    async openInTab (url) {
      window.open(url, '_blank').focus()
    },
    async getData () {
      this.loading = true
      if (process.env.NODE_ENV === 'development') console.log('--> Loading reports from registration', this.filters)
      if (this.useFacilityDescription) {
        const facilities = await loadFacilities(0)
        const facilityNrs = facilities.data.filter(f => this.filters.FacilityArray.includes(f.Description)).map(f => f.No)
        const facilitiesResDescription = _.cloneDeep(this.filters)
        facilitiesResDescription.FacilityArray = facilityNrs
        const reportRes = await Reports.loadReportData(facilitiesResDescription)
        if (!reportRes.failed) {
          if (process.env.NODE_ENV === 'development') console.log('--> Reports loaded', reportRes)
          this.results = reportRes.data.Data
        }
        this.loading = false
        return
      }

      const reportRes = await Reports.loadReportData(this.filters)
      if (!reportRes.failed) {
        if (process.env.NODE_ENV === 'development') console.log('--> Reports loaded', reportRes)
        this.results = reportRes.data.Data
      }
      this.loading = false
      /* console.log('pop4', this.translatedHeaders)
      for (let i = 0; i < this.translatedHeaders.length; i++) {
        if (this.translatedHeaders[i].text === 'Print') {
          this.translatedHeaders[i].visible = this.showComfirmationPrint
        }
      } */
    },
    print () {
      // this.showLogo = true
      // if (process.env.NODE_ENV === 'development') console.log('--> Window location', window.location)
      window.print()
      // this.showLogo = false
    },
    pdf () {
      // printJS('section-to-print', 'html')
      // printJS({ printable: 'section-to-printx', type: 'html', header: 'SomeHeader' })
    },
    download () {
      const headers = this.filteredHeaders.map(header => header.text)
      const data = this.results.map(row => {
        return this.filteredHeaders.map(header => {
          if (header.value === 'DateFirst' || header.value === 'DateSecond' ||
            header.value === 'UpdatedDate' || header.value === 'CreatedDate') return this.formatDate(row[header.value])
          else if (header.value === 'DateFirstDate' || header.value === 'DateSecondDate') return this.formatDateDateOnly(row[header.value])
          else if (header.value === 'DateFirstTime' || header.value === 'DateSecondTime') return this.formatDateTimeOnly(row[header.value])
          else return row[header.value]
        })
      })
      downloadExcel(headers, data)
    }
  },
  computed: {
    formattedResults () {
      return this.results.map(result => {
        const obj = Object.assign({}, result)
        obj.DateFirst = this.formatDate(result.DateFirst)
        obj.DateSecond = this.formatDate(result.DateSecond)
        obj.DateFirstDate = this.formatDateDateOnly(result.DateFirst)
        obj.DateSecondDate = this.formatDateDateOnly(result.DateSecond)
        obj.DateFirstTime = this.formatDateTimeOnly(result.DateFirst)
        obj.DateSecondTime = this.formatDateTimeOnly(result.DateSecond)
        return obj
      })
    },
    translatedHeaders () {
      return this.headers.map(header => {
        const h = { ...header }
        h.text = this.$t(header.text)
        return h
      })
    },
    filteredHeaders () {
      return this.translatedHeaders.filter(header => header.visible)
    }
  }
}
</script>

<style>
  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;
  }
  .theme--light.v-data-table thead tr th {
    color: rgba(0, 0, 0, 1);
  }
  .v-data-table-header th {
    white-space: nowrap;
  }
  tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .05);
  }

@media print {
  .show-on-print {
    display: block !important;
  }
  body * {
    visibility: hidden;
  }
  #section-to-print, #section-to-print * {
    visibility: visible;
  }
  #section-to-print {
    position:absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  #table-to-print {
    position: absolute;
    left: 0;
    top: auto;
  }
  .v-main {
    padding: 0 !important;
  }
  .v-data-table td {
    font: 16px;
  }
  tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .05);
  }
}
</style>
